import React, { Component } from 'react';
import {
  Page,
  Layout,
  Card,
  FormLayout,
  TextField,
  Banner,
  SettingToggle,
  Text,
  Checkbox,
  PageActions,
  Select,
  TextContainer,
  OptionList,
  ResourceList,
  ResourceItem,
  Tooltip,
  Icon,
  LegacyStack,
} from '@shopify/polaris';
import { InfoMinor } from '@shopify/polaris-icons';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { ColorPickerCustom } from './ColorPickerCustom';
import { EmojiPickerCustom } from './EmojiPickerCustom';
import { CountryPickerCustom } from './CountryPickerCustom';
import { CartSliderShippingBar } from './CartSliderShippingBar';
import { CartSliderCartReserved } from './CartSliderCartReserved';
import { CartSliderInCartUpsell } from './CartSliderInCartUpsell';
import { type } from 'jquery';
import { fetchApi } from './helpers/fetchApi';
import './CartSlider.css';
import { isBannerDismissed, dismissBanner } from './helpers/bannerSession';
import { GlobalPlanBanners } from './GlobalPlanBanners';


const $ = window.$;

var fontStepValSmall = -2;
var fontStepValIncrease = 2;

export class CartSlider extends Component {

  constructor(props, ref) {
    super(props);
    props.setIsLoading(true);
    this.saveChanges = this.saveChanges.bind(this);
    this.handleSectionSettings = this.handleSectionSettings.bind(this);
    this.updateSectionSettingsPreview = this.updateSectionSettingsPreview.bind(this);
    this.getDefaultFontValuesSectionSettings = this.getDefaultFontValuesSectionSettings.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.discardChanges = this.discardChanges.bind(this);
    this.handleCartReserve = this.handleCartReserve.bind(this);
    this.getDefaultFontValuesCartReserve = this.getDefaultFontValuesCartReserve.bind(this);
    this.updateCartReservePreview = this.updateCartReservePreview.bind(this);
    this.getDefaultFontValuesInCartUpsell = this.getDefaultFontValuesInCartUpsell.bind(this);
    this.updateInCartUpsellPreview = this.updateInCartUpsellPreview.bind(this);
    this.handleInCartUpsell = this.handleInCartUpsell.bind(this);
    this.handleShippingCart = this.handleShippingCart.bind(this);
    this.updateShippingCartPreview = this.updateShippingCartPreview.bind(this);
    this.getDefaultFontValuesShippingCart = this.getDefaultFontValuesShippingCart.bind(this);
    this.handleChangeOptions = this.handleChangeOptions.bind(this);
    this.togglePreviewActive = this.togglePreviewActive.bind(this);
    this.handleChangeDemoQty = this.handleChangeDemoQty.bind(this);
    this.handleDemoQtyUpDown = this.handleDemoQtyUpDown.bind(this);
    this.removeItem = this.removeItem.bind(this);

    this.state = {
      initState: {},
      model: {},
      DefaultFontSizeSectionSettings: {},
      DefaultFontSizeCartReserve: {},
      DefaultFontSizeInCartUpSell: {},
      DefaultFontSizeShippingCart: {},
      loading: true,
      common: this.props.common,
      selectedBundles: [],
      previewActive: true,
      demoQty: 1,
      visibleItem: true,
      showFreePlanBanner: true,
      _bannerTick: true,
      error: {
        closeAfterSeconds: false,
        countdownMinutes_CartReserved: false,
        notShowHours_CartReserved: false,
        messageFontSize_CartReserved: false,
        minAmount_ShippingBar: false,
        bundledProductsCount_InCartUpsell: false,
      },
    };
  }

  componentDidMount() {
    this.populateData();
    this.props.setSaveChanges(this.saveChanges);
    this.props.setDiscardChanges(this.discardChanges);
  }

  discardChanges() {
    this.setState({
      model: Object.assign({}, this.state.initState),
      initState: Object.assign({}, this.state.initState),
    });
  }

  handleChange(fieldName, newValue) {
    window?.shopify?.saveBar?.show('satcb-save-bar');

    this.setState((prevState) => {
      let model = Object.assign({}, prevState.model);
      model[fieldName] = newValue;
      const isDirty = JSON.stringify(this.state.initState) !== JSON.stringify(model);
      this.props.setIsDirty(isDirty);
      if (!isDirty) {
        window?.shopify?.saveBar?.hide('satcb-save-bar');
      }
      return { model };
    });
  }

  handleSectionSettings(newValue) {
    this.handleChange('titleFontSize', newValue);
    this.updateSectionSettingsPreview(newValue, this.getDefaultFontValuesSectionSettings());
  }

  handleCartReserve(newValue) {
    this.handleChange('cartInfoFontSize_CartReserved', newValue);
    this.updateCartReservePreview(newValue, this.getDefaultFontValuesCartReserve());
  }

  handleInCartUpsell(newValue) {
    this.handleChange('cartFontSize_InCartUpsell', newValue);
    this.updateInCartUpsellPreview(newValue, this.getDefaultFontValuesInCartUpsell());
  }

  handleShippingCart(newValue) {
    this.handleChange('shippingFontSize_ShippingBar', newValue);
    this.updateShippingCartPreview(newValue, this.getDefaultFontValuesShippingCart());
  }

  getDefaultFontValuesShippingCart() {
    if (Object.keys(this.state.DefaultFontSizeShippingCart).length === 0) {
      let elements = {
        shippingCartText1: window.$('.satcb-cs-shippingbar span'),
      };

      var fontSizes = {};
      window?.$?.each(elements, (key, val) => {
        fontSizes[key] = parseFloat(val.css('font-size'));
      });

      this.setState({ DefaultFontSizeShippingCart: fontSizes });
      return fontSizes;
    }
  }

  updateShippingCartPreview(value, defaultFont) {
    let elements = {
      shippingCartText1: window.$('.satcb-cs-shippingbar span'),
    };

    if (defaultFont === undefined) {
      defaultFont = this.state.DefaultFontSizeShippingCart;
    }

    if (value === '') {
      window?.$?.each(defaultFont, (key, size) => {
        elements[key].css('font-size', defaultFont[key] + 'px');
      });
      return;
    }

    let stepVal = parseFloat(value);
    window?.$?.each(defaultFont, (key, size) => {
      let newSize = size + stepVal;
      elements[key].css('font-size', newSize + 'px');
    });
  }

  getDefaultFontValuesInCartUpsell() {
    if (Object.keys(this.state.DefaultFontSizeInCartUpSell).length === 0) {
      let elements = {
        inCartUpsellText1: window.$('.satcb-cs-upsell-item-header span'),
        inCartUpsellTitle: window.$('.satcb-cs-upsell-item-title'),
        inCartUpsellQty: window.$('.satcb-cs-upsell-item-content .satcb-cs-item-qty input[type=text]'),
        inCartUpsellPrice: window.$('.satcb-cs-upsell-item-price'),
        inCartUpsellBtn: window.$('.satcb-cs-upsell-item-atc'),
      };

      var fontSizes = {};
      window?.$?.each(elements, (key, val) => {
        fontSizes[key] = parseFloat(val.css('font-size'));
      });

      this.setState({ DefaultFontSizeInCartUpSell: fontSizes });

      return fontSizes;
    }
  }

  updateInCartUpsellPreview(value, defaultFont) {
    let elements = {
      inCartUpsellText1: window.$('.satcb-cs-upsell-item-header span'),
      inCartUpsellTitle: window.$('.satcb-cs-upsell-item-title'),
      inCartUpsellQty: window.$('.satcb-cs-upsell-item-content .satcb-cs-item-qty input[type=text]'),
      inCartUpsellPrice: window.$('.satcb-cs-upsell-item-price'),
      inCartUpsellBtn: window.$('.satcb-cs-upsell-item-atc'),
    };

    if (defaultFont === undefined) {
      defaultFont = this.state.DefaultFontSizeInCartUpSell;
    }
    if (value === '') {
      $?.each(defaultFont, (key, size) => {
        elements[key].css('font-size', defaultFont[key] + 'px');
      });
      return;
    }

    let stepVal = parseFloat(value);
    window?.$?.each(defaultFont, (key, size) => {
      let newSize = size + stepVal;
      elements[key].css('font-size', newSize + 'px');
    });
  }

  getDefaultFontValuesSectionSettings() {
    if (Object.keys(this.state.DefaultFontSizeSectionSettings).length === 0) {
      var elements = {
        title: window.$('.satcb-cs-header-title'),
        countVal: window.$('.satcb-cs-header-count'),
        subTotal: window.$('.satcb-cs-footer-subtotal span:first-child'),
        subTotalPrice: window.$('.satcb-cs-footer-subtotal span:last-child'),
        textShipping: window.$('.satcb-cs-taxes-shipping-note'),
        checkoutBtn: window.$('.satcb-cs-checkout-btn'),
        viewCart: window.$('.satcb-cs-view-cart'),
        continueShopping: window.$('.satcb-cs-continue-shopping'),
        proTitle: window.$('.satcb-cs-items .satcb-cs-item .satcb-cs-item-title a'),
        proQuantity: window.$('.satcb-cs-items .satcb-cs-item-qty input[type=text]'),
        proPrice: window.$('.satcb-cs-items .satcb-cs-item-price'),
        proVariant: window.$('.satcb-cs-items .satcb-cs-item-variant'),
      };

      var fontSizes = {};
      window?.$?.each(elements, (key, val) => {
        fontSizes[key] = parseFloat(val.css('font-size'));
      });

      this.setState({ DefaultFontSizeSectionSettings: fontSizes });

      return fontSizes;
    }
  }

  updateSectionSettingsPreview(Value, defaultFont) {
    var elements = {
      title: window.$('.satcb-cs-header-title'),
      countVal: window.$('.satcb-cs-header-count'),
      subTotal: window.$('.satcb-cs-footer-subtotal span:first-child'),
      subTotalPrice: window.$('.satcb-cs-footer-subtotal span:last-child'),
      textShipping: window.$('.satcb-cs-taxes-shipping-note'),
      checkoutBtn: window.$('.satcb-cs-checkout-btn'),
      viewCart: window.$('.satcb-cs-view-cart'),
      continueShopping: window.$('.satcb-cs-continue-shopping'),
      proTitle: window.$('.satcb-cs-items .satcb-cs-item .satcb-cs-item-title a'),
      proQuantity: window.$('.satcb-cs-items .satcb-cs-item-qty input[type=text]'),
      proPrice: window.$('.satcb-cs-items .satcb-cs-item-price'),
      proVariant: window.$('.satcb-cs-items .satcb-cs-item-variant'),
    };

    if (defaultFont === undefined) {
      defaultFont = this.state.DefaultFontSizeSectionSettings;
    }
    if (Value === '') {
      window?.$?.each(defaultFont, (key, size) => {
        elements[key].css('font-size', defaultFont[key] + 'px');
      });
      return;
    }

    let stepVal = parseFloat(Value);
    window?.$?.each(defaultFont, (key, size) => {
      let newSize = size + stepVal;
      elements[key].css('font-size', newSize + 'px');
    });
  }

  getDefaultFontValuesCartReserve() {
    if (Object.keys(this.state.DefaultFontSizeCartReserve).length === 0) {
      let elements = {
        cartReserveText1: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-bold').prev(),
        cartReserveText2: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-bold span:first-child'),
        cartReserveTime: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-timer'),
        cartReserveText3: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-timer').next(),
      };

      var fontSizes = {};
      window?.$?.each(elements, (key, val) => {
        fontSizes[key] = parseFloat(val.css('font-size'));
      });

      this.setState({ DefaultFontSizeCartReserve: fontSizes });

      return fontSizes;
    }
  }

  updateCartReservePreview(value, defaultFont) {
    let elements = {
      cartReserveText1: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-bold').prev(),
      cartReserveText2: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-bold span:first-child'),
      cartReserveTime: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-timer'),
      cartReserveText3: window.$('.satcb-cs-cartReserved .satcb-cs-cartReserved-timer').next(),
    };

    if (defaultFont === undefined) {
      defaultFont = this.state.DefaultFontSizeCartReserve;
    }

    if (value === '') {
      window?.$?.each(defaultFont, (key, size) => {
        elements[key].css('font-size', defaultFont[key] + 'px');
      });
      return;
    }

    let stepVal = parseFloat(value);
    window?.$?.each(defaultFont, (key, size) => {
      let newSize = size + stepVal;
      elements[key].css('font-size', newSize + 'px');
    });
  }

  handleChangeOptions(newValue) {
    if (newValue == '0') {
      this.handleChange('clearLowQuantityItemsFromCartOnTimerEnd_CartReserved', false);
      this.handleChange('clearCartOnTimerEnd_CartReserved', false);
      this.handleChange('selectedRemoveProductOption_CartReserved', '0');
    } else if (newValue == '1') {
      this.handleChange('clearLowQuantityItemsFromCartOnTimerEnd_CartReserved', true);
      this.handleChange('clearCartOnTimerEnd_CartReserved', false);
      this.handleChange('selectedRemoveProductOption_CartReserved', '1');
    } else if (newValue == '2') {
      this.handleChange('clearCartOnTimerEnd_CartReserved', true);
      this.handleChange('clearLowQuantityItemsFromCartOnTimerEnd_CartReserved', false);
      this.handleChange('selectedRemoveProductOption_CartReserved', '2');
    }
  }

  selectBundles(newValue) {
    this.setState({ selectedBundles: newValue });
  }

  deleteBundles() {
    var items = this.state.model.bundles_InCartUpsell.filter(
      (option) => this.state.selectedBundles.indexOf(option.id) === -1
    );
    this.handleChange('bundles_InCartUpsell', items);
    this.selectBundles([]);
  }

  togglePreviewActive() {
    const showDemo = !this.state.previewActive;
    this.setState({ previewActive: showDemo });

    setTimeout(() => {
      const $content = window.$('.satcb-cs-content');

      if (showDemo) {
        window.$('.satcb-cs').addClass('satcb-cs-open');
        // do NOT add body modal class in admin preview
        $content.stop(true, true).css({ marginRight: 0 });
      } else {
        $content.stop(true, true).animate(
          { marginRight: -$content.outerWidth() },
          250,
          function () {
            window.$('.satcb-cs').removeClass('satcb-cs-open');
          }
        );
      }
    }, 0);
  }

  handleChangeDemoQty(event) {
    this.setState({ demoQty: event.target.value });
  }

  handleDemoQtyUpDown(value, e) {
    e.preventDefault();
    var val = this.state.demoQty + value;
    if (val > 0) {
      this.setState({ demoQty: val });
    }
  }

  handleBlur(fieldName, minValue) {
    var val = parseFloat(this.state.model[fieldName]);
    var hasError = !(val >= minValue);

    this.setState((prevState) => {
      let error = Object.assign({}, prevState.error);
      error[fieldName] = hasError;
      return { error };
    });

    return hasError;
  }

  removeItem() {
    this.setState({ visibleItem: false });
  }

  getCurrencySymbol() {
    var symbol = this.state.common.currency;
    switch (symbol) {
      case 'USD':
        symbol = '$';
        break;
      case 'EUR':
        symbol = '€';
        break;
      default:
        symbol += ' ';
        break;
    }

    return symbol;
  }

  render() {
    let token = !window.navigate ? `&token=${new URLSearchParams(window.location.search).get('token')}` : '';

    let lblCustomBundles = (
      <span>
        <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">Custom bundles</b>
        <br />
        <span>Consider bundling related or frequently purchased items together.</span>
      </span>
    );

    let lblSmartRecommendation = (
      <span>
        <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">Smart recommendations</b>
        <br />
        <span>Leverage the customer's purchase history and behavior to suggest products they are likely to be interested in.</span>
      </span>
    );

    let lblGlobalRecommendation = (
      <span>
        <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">
          Global recommendations
          <Tooltip content="To add products as global recommendations tag them with the exact text 'Global upsell recommendations'">
            <div style={{ lineHeight: 'normal', marginLeft: '4px', display: 'inline-block', marginBottom: '-4px' }}>
              <Icon source={InfoMinor} color="inkLightest" />
            </div>
          </Tooltip>
        </b>
        <br />
        <span>Based on manual tagging of products, use for promoting seasonal or trending items, bestsellers, or special promotions.</span>
      </span>
    );

    let lblSameCollection = (
      <span>
        <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">Same collection</b>
        <br />
        <span>Suggests products within the Same collection, which often share a theme or purpose.</span>
      </span>
    );

    let lblSameProductType = (
      <span>
        <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">Same product type</b>
        <br />
        <span>Recommending products of the same type, like different laptop models, can help customers find alternatives or upgrades.</span>
      </span>
    );

    let lblSameVendor = (
      <span>
        <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">Same vendor</b>
        <br />
        <span>Promotes items that are compatible in terms of brand or manufacturer.</span>
      </span>
    );

    let lblRandomProduct = (
      <span>
        <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">Random product</b>
        <br />
        <span>When other recommendations don't apply, random products offer variety and can spark interest, helping customers discover new products.</span>
      </span>
    );

    return this.state.loading ? (
      <SkeletonPageCustom />
    ) : (
      <Page title="Cart slider">
          <GlobalPlanBanners common={this.props.common} url={window.location.search} />
        <br />

        {/* ======= 70/30 LAYOUT WRAPPER ======= */}
        <div className="cs-editor"> 
          {/* LEFT 70% CONTROLS */}
          <div className="cs-editor__left">
            <Layout>
              <Layout.Section>
                <Card>
                  <Card.Section>
                    <LegacyStack alignment="leading" spacing="tight">
                      <LegacyStack.Item>
                        <Icon source={InfoMinor} />
                      </LegacyStack.Item>

                      <LegacyStack.Item>
                        <Text as="h3" variant="headingSm">
                          What is Cart slider?
                        </Text>
                      </LegacyStack.Item>

                      <LegacyStack.Item fill>
                        <div style={{ marginTop: 4 }}>
                          <Text as="p" variant="bodyMd">
                            Cart Slider is an interactive cart drawer that appears when a product is added to the cart instead
                            of redirecting customers to the Cart page. It improves user experience and keeps shoppers on the
                            current page. You can enable features like cart reservation timer, shipping progress bar, and in cart
                            upsells to reduce cart abandonment and increase average order value.
                          </Text>
                        </div>
                      </LegacyStack.Item>
                    </LegacyStack>
                  </Card.Section>
                </Card>
              </Layout.Section>

              <Layout.AnnotatedSection title="Cart slider state">
                <div className="setting-toggle-card">
                  <Card>
                    <SettingToggle
                      action={{
                        content: this.state.model.enabled ? 'Disable' : 'Enable',
                        onAction: () => {
                          this.handleChange('enabled', !this.state.model.enabled);
                        },
                      }}
                      enabled={this.state.model.enabled}
                    >
                      Cart slider is currently{' '}
                      <Text as="span" fontWeight="semibold">
                        {this.state.model.enabled ? 'enabled' : 'disabled'}
                      </Text>
                      .
                    </SettingToggle>
                    <Card.Section>
                      <TextContainer>
                        {!isBannerDismissed('CartSlider.PopupDrawerDisable') && (

                        <Banner
                            onDismiss={() => {
                                    dismissBanner('CartSlider.PopupDrawerDisable');
                                    this.setState((p) => ({ _bannerTick: (p._bannerTick || 0) + 1 }));
                                }}
                          >
                          <p>Please note, if your theme has a popup/drawer cart you should disable it in the theme settings.</p>
                        </Banner>
                        )}
                      </TextContainer>
                    </Card.Section>
                  </Card>
                </div>
              </Layout.AnnotatedSection>

              <Layout.AnnotatedSection title="Settings">
                <Card>
                  <Card.Section>
                    <FormLayout>
                      <Checkbox
                        label="Open on Add to Cart"
                        checked={this.state.model.openOnAddToCart}
                        onChange={(newValue) => this.handleChange('openOnAddToCart', newValue)}
                      />
                      {this.state.model.openOnAddToCart ? (
                        <FormLayout.Group>
                          <Checkbox
                            label="Close after"
                            checked={this.state.model.closeAfter}
                            onChange={(newValue) => this.handleChange('closeAfter', newValue)}
                          />
                          <TextField
                            id="cartSlider_closeAfterSeconds"
                            suffix="seconds"
                            type="number"
                            min="2"
                            disabled={!this.state.model.closeAfter}
                            value={this.state.model.closeAfterSeconds}
                            onChange={(newValue) => this.handleChange('closeAfterSeconds', newValue)}
                            error={this.state.error.closeAfterSeconds ? 'Value must be greater than or equal to 2' : ''}
                            onBlur={() => this.handleBlur('closeAfterSeconds', 2)}
                          />
                        </FormLayout.Group>
                      ) : (
                        ''
                      )}
                      <Checkbox
                        label="Show view cart link"
                        checked={this.state.model.showViewCart}
                        onChange={(newValue) => this.handleChange('showViewCart', newValue)}
                      />
                      <Checkbox
                        label="Show continue shopping link"
                        checked={this.state.model.showContinueShopping}
                        onChange={(newValue) => this.handleChange('showContinueShopping', newValue)}
                      />
                      <Checkbox
                        label="Fixed footer"
                        checked={this.state.model.stickyFooter}
                        onChange={(newValue) => this.handleChange('stickyFooter', newValue)}
                      />
                      <Checkbox
                        label="Show trust badges"
                        checked={this.state.model.showTrustBadges}
                        onChange={(newValue) => this.handleChange('showTrustBadges', newValue)}
                      />
                      {this.state.model.showTrustBadges ? (
                        <FormLayout.Group>
                          <Checkbox
                            label="Visa"
                            checked={this.state.model.showTrustBadgesVisa}
                            onChange={(newValue) => this.handleChange('showTrustBadgesVisa', newValue)}
                          />
                          <Checkbox
                            label="Mastercard"
                            checked={this.state.model.showTrustBadgesMastercard}
                            onChange={(newValue) => this.handleChange('showTrustBadgesMastercard', newValue)}
                          />
                          <Checkbox
                            label="American Express"
                            checked={this.state.model.showTrustBadgesAmericanExpress}
                            onChange={(newValue) => this.handleChange('showTrustBadgesAmericanExpress', newValue)}
                          />
                          <Checkbox
                            label="Paypal"
                            checked={this.state.model.showTrustBadgesPaypal}
                            onChange={(newValue) => this.handleChange('showTrustBadgesPaypal', newValue)}
                          />
                          <Checkbox
                            label="G Pay"
                            checked={this.state.model.showTrustBadgesGPay}
                            onChange={(newValue) => this.handleChange('showTrustBadgesGPay', newValue)}
                          />
                          <Checkbox
                            label="Apple Pay"
                            checked={this.state.model.showTrustBadgesApplePay}
                            onChange={(newValue) => this.handleChange('showTrustBadgesApplePay', newValue)}
                          />
                        </FormLayout.Group>
                      ) : (
                        ''
                      )}
                      <TextField
                        value={this.state.model.cartButtonCSSSelector}
                        onChange={(newValue) => this.handleChange('cartButtonCSSSelector', newValue)}
                        label="Cart button CSS selector"
                      />
                    </FormLayout>
                  </Card.Section>

                  <Card.Section title="Translations">
                    <FormLayout>
                      <FormLayout.Group>
                        <TextField
                          value={this.state.model.cartTitle_Translation}
                          onChange={(newValue) => this.handleChange('cartTitle_Translation', newValue)}
                          label="Cart title"
                        />
                        <TextField
                          value={this.state.model.cartEmptyText_Translation}
                          onChange={(newValue) => this.handleChange('cartEmptyText_Translation', newValue)}
                          label="Cart empty text"
                        />
                      </FormLayout.Group>
                      <FormLayout.Group>
                        <TextField
                          value={this.state.model.checkoutButtonText_Translation}
                          onChange={(newValue) => this.handleChange('checkoutButtonText_Translation', newValue)}
                          label="Checkout button text"
                        />
                        <TextField
                          value={this.state.model.continueShoppingText_Translation}
                          onChange={(newValue) => this.handleChange('continueShoppingText_Translation', newValue)}
                          label="Continue shopping text"
                        />
                      </FormLayout.Group>
                      <FormLayout.Group>
                        <TextField
                          value={this.state.model.subtotal_Translation}
                          onChange={(newValue) => this.handleChange('subtotal_Translation', newValue)}
                          label="Subtotal label"
                        />
                        <TextField
                          value={this.state.model.viewCartText_Translation}
                          onChange={(newValue) => this.handleChange('viewCartText_Translation', newValue)}
                          label="View cart text"
                        />
                      </FormLayout.Group>
                      <FormLayout.Group>
                        <TextField
                          value={this.state.model.taxesAndShippingNote_Translation}
                          onChange={(newValue) => this.handleChange('taxesAndShippingNote_Translation', newValue)}
                          label="Taxes and shipping note"
                        />
                      </FormLayout.Group>
                    </FormLayout>
                  </Card.Section>

                  <Card.Section title="Look and feel">
                    <FormLayout>
                      <FormLayout.Group>
                        <ColorPickerCustom
                          label="Checkout Button background color"
                          fieldName="checkoutButtonBackgroundColor"
                          value={this.state.model.checkoutButtonBackgroundColor}
                          handleChange={this.handleChange}
                        />
                        <ColorPickerCustom
                          label="Checkout button color"
                          fieldName="checkoutButtonColor"
                          value={this.state.model.checkoutButtonColor}
                          handleChange={this.handleChange}
                        />
                        <Select
                          label="Section font size"
                          options={[
                            { label: 'Small', value: JSON.stringify(fontStepValSmall) },
                            { label: 'Medium', value: '' },
                            { label: 'Large', value: JSON.stringify(fontStepValIncrease) },
                            { label: 'Extra Large', value: JSON.stringify(fontStepValIncrease + 2) },
                          ]}
                          onChange={this.handleSectionSettings}
                          value={this.state.model.titleFontSize}
                        />

                        <Select
                          label="Override font face"
                          options={[
                            { label: 'Default', value: '' },
                            { label: 'Roboto', value: 'Roboto' },
                            { label: 'Playfair Display', value: 'Playfair Display' },
                            { label: 'Open Sans', value: 'Open Sans' },
                            { label: 'Oswald', value: 'Oswald' },
                            { label: 'Cabin', value: 'Cabin' },
                            { label: 'Montserrat', value: 'Montserrat' },
                            { label: 'Merriweather', value: 'Merriweather' },
                            { label: 'Cormorant', value: 'Cormorant' },
                            { label: 'Poppins', value: 'Poppins' },
                            { label: 'Nunito', value: 'Nunito' },
                            { label: 'Lato', value: 'Lato' },
                          ]}
                          onChange={(newValue) => this.handleChange('fontFace', newValue)}
                          value={this.state.model.fontFace}
                        />
                      </FormLayout.Group>
                    </FormLayout>
                  </Card.Section>
                </Card>
              </Layout.AnnotatedSection>

              <Layout.AnnotatedSection title="Cart reserved">
                <Card sectioned>
                  <FormLayout>
                    <Checkbox
                      label="Enabled"
                      checked={this.state.model.enabled_CartReserved}
                      onChange={(newValue) => this.handleChange('enabled_CartReserved', newValue)}
                    />
                    {this.state.model.enabled_CartReserved && (
                      <span>
                        <FormLayout.Group>
                          <TextField
                            id="cartSlider_countdownMinutes_CartReserved"
                            label="Timer duration"
                            suffix="Minute(s)"
                            type="number"
                            min="1"
                            value={this.state.model.countdownMinutes_CartReserved}
                            onChange={(newValue) => this.handleChange('countdownMinutes_CartReserved', newValue)}
                            error={this.state.error.countdownMinutes_CartReserved ? 'Value must be greater than or equal to 1' : ''}
                            onBlur={() => this.handleBlur('countdownMinutes_CartReserved', 1)}
                          />
                          <ColorPickerCustom
                            label="Color of timer"
                            fieldName="colorOfTimer_CartReserved"
                            value={this.state.model.colorOfTimer_CartReserved}
                            handleChange={this.handleChange}
                          />
                        </FormLayout.Group>

                        <FormLayout.Group>
                          <ColorPickerCustom
                            label="Background color"
                            fieldName="backgroundColor_CartReserved"
                            value={this.state.model.backgroundColor_CartReserved}
                            handleChange={this.handleChange}
                          />
                          <ColorPickerCustom
                            label="Text color"
                            fieldName="textColor_CartReserved"
                            value={this.state.model.textColor_CartReserved}
                            handleChange={this.handleChange}
                          />
                        </FormLayout.Group>

                        <FormLayout.Group>
                          <ColorPickerCustom
                            label="Border color"
                            fieldName="borderColor_CartReserved"
                            value={this.state.model.borderColor_CartReserved}
                            handleChange={this.handleChange}
                          />
                          <TextField
                            label="Border radius"
                            suffix="px"
                            type="number"
                            value={this.state.model.borderRadius_CartReserved}
                            onChange={(newValue) => this.handleChange('borderRadius_CartReserved', newValue)}
                            clearButton
                            onClearButtonClick={() => this.handleChange('borderRadius_CartReserved', null)}
                          />
                        </FormLayout.Group>

                        <FormLayout.Group>
                          <Select
                            label="Remove items from cart after timer expires"
                            options={[
                              { label: "Don't remove items", value: '0' },
                              { label: 'Only remove low inventory items', value: '1' },
                              { label: 'Remove all items', value: '2' },
                            ]}
                            onChange={(newValue) => this.handleChangeOptions(newValue)}
                            value={this.state.model.selectedRemoveProductOption_CartReserved}
                          />

                          <TextField
                            label="Thresold inventory level"
                            suffix="items"
                            type="number"
                            min="1"
                            disabled={!this.state.model.clearLowQuantityItemsFromCartOnTimerEnd_CartReserved}
                            value={this.state.model.lowQuantityThreshold_CartReserved}
                            onChange={(newValue) => this.handleChange('lowQuantityThreshold_CartReserved', newValue)}
                          />
                        </FormLayout.Group>

                        <TextField
                          id="cartSlider_notShowHours_CartReserved"
                          label="Do not show expired Timer to the same visitor again for a number of hours"
                          suffix="Hour(s)"
                          type="number"
                          min="0"
                          value={this.state.model.notShowHours_CartReserved}
                          onChange={(newValue) => this.handleChange('notShowHours_CartReserved', newValue)}
                          error={this.state.error.notShowHours_CartReserved ? 'Value must be greater than or equal to 0' : ''}
                          onBlur={() => this.handleBlur('notShowHours_CartReserved', 0)}
                        />

                        <TextField
                          value={this.state.model.message_CartReserved}
                          onChange={(newValue) => this.handleChange('message_CartReserved', newValue)}
                          label="Message"
                        />

                        <FormLayout.Group>
                          <TextField
                            value={this.state.model.messageBeforeTimer_CartReserved}
                            onChange={(newValue) => this.handleChange('messageBeforeTimer_CartReserved', newValue)}
                            label="Message before timer"
                          />
                          <TextField
                            value={this.state.model.messageAfterTimer_CartReserved}
                            onChange={(newValue) => this.handleChange('messageAfterTimer_CartReserved', newValue)}
                            label="Message after timer"
                          />
                        </FormLayout.Group>

                        <FormLayout.Group>
                          <EmojiPickerCustom
                            label="Emoji in front of the message"
                            fieldName="emoji_CartReserved"
                            value={this.state.model.emoji_CartReserved}
                            handleChange={this.handleChange}
                          />
                          <TextField
                            id="cartSlider_messageFontSize_CartReserved"
                            label="Message font size"
                            suffix="px"
                            type="number"
                            min="1"
                            value={this.state.model.messageFontSize_CartReserved}
                            onChange={(newValue) => this.handleChange('messageFontSize_CartReserved', newValue)}
                            error={this.state.error.messageFontSize_CartReserved ? 'Value must be greater than or equal to 1' : ''}
                            onBlur={() => this.handleBlur('messageFontSize_CartReserved', 1)}
                          />
                        </FormLayout.Group>

                        <Select
                          label="Position"
                          options={[
                            { label: 'Top', value: 'top' },
                            { label: 'Bottom', value: 'bottom' },
                          ]}
                          onChange={(newValue) => this.handleChange('position_CartReserved', newValue)}
                          value={this.state.model.position_CartReserved}
                        />

                        <Select
                          label="Cart message Font Size"
                          options={[
                            { label: 'Small', value: JSON.stringify(fontStepValSmall) },
                            { label: 'Medium', value: '' },
                            { label: 'Large', value: JSON.stringify(fontStepValIncrease) },
                            { label: 'Extra Large', value: JSON.stringify(fontStepValIncrease + 2) },
                          ]}
                          onChange={this.handleCartReserve}
                          value={this.state.model.cartInfoFontSize_CartReserved}
                        />
                      </span>
                    )}
                  </FormLayout>
                </Card>
              </Layout.AnnotatedSection>

              <Layout.AnnotatedSection title="Shipping bar">
                <Card sectioned>
                  <FormLayout>
                    <Checkbox
                      label="Enabled"
                      checked={this.state.model.enabled_ShippingBar}
                      onChange={(newValue) => this.handleChange('enabled_ShippingBar', newValue)}
                    />
                    {this.state.model.enabled_ShippingBar && (
                      <span>
                        <CountryPickerCustom
                          options={this.state.common.countries}
                          label="Countries eligible for free shipping (leave empty for all)"
                          fieldName="eligibleCountries_ShippingBar"
                          value={this.state.model.eligibleCountries_ShippingBar}
                          handleChange={this.handleChange}
                        />

                        <FormLayout.Group>
                          <TextField
                            id="cartSlider_minAmount_ShippingBar"
                            label="Min amount to spend"
                            suffix={this.state.common.currency}
                            type="number"
                            min="0"
                            value={this.state.model.minAmount_ShippingBar}
                            onChange={(newValue) => this.handleChange('minAmount_ShippingBar', newValue)}
                            error={this.state.error.minAmount_ShippingBar ? 'Value must be greater than or equal to 0' : ''}
                            onBlur={() => this.handleBlur('minAmount_ShippingBar', 0)}
                          />
                          <ColorPickerCustom
                            label="Amount color"
                            fieldName="amountColor_ShippingBar"
                            value={this.state.model.amountColor_ShippingBar}
                            handleChange={this.handleChange}
                          />
                        </FormLayout.Group>

                        <FormLayout.Group>
                          <ColorPickerCustom
                            label="Background color"
                            fieldName="backgroundColor_ShippingBar"
                            value={this.state.model.backgroundColor_ShippingBar}
                            handleChange={this.handleChange}
                          />
                          <ColorPickerCustom
                            label="Text color"
                            fieldName="textColor_ShippingBar"
                            value={this.state.model.textColor_ShippingBar}
                            handleChange={this.handleChange}
                          />
                        </FormLayout.Group>

                        <FormLayout.Group>
                          <TextField
                            value={this.state.model.initialMessageBeforeAmount_ShippingBar}
                            onChange={(newValue) => this.handleChange('initialMessageBeforeAmount_ShippingBar', newValue)}
                            label="Initial message before amount"
                          />
                          <TextField
                            value={this.state.model.initialMessageAfterAmount_ShippingBar}
                            onChange={(newValue) => this.handleChange('initialMessageAfterAmount_ShippingBar', newValue)}
                            label="Initial message after amount"
                          />
                        </FormLayout.Group>

                        <FormLayout.Group>
                          <TextField
                            value={this.state.model.progressMessageBeforeAmount_ShippingBar}
                            onChange={(newValue) => this.handleChange('progressMessageBeforeAmount_ShippingBar', newValue)}
                            label="Progress message before amount"
                          />
                          <TextField
                            value={this.state.model.progressMessageAfterAmount_ShippingBar}
                            onChange={(newValue) => this.handleChange('progressMessageAfterAmount_ShippingBar', newValue)}
                            label="Progress message after amount"
                          />
                        </FormLayout.Group>

                        <TextField
                          value={this.state.model.goalAchievedMessage_ShippingBar}
                          onChange={(newValue) => this.handleChange('goalAchievedMessage_ShippingBar', newValue)}
                          label="Goal achieved message"
                          helpText={
                            <div>
                              You can use emojis as well, copy them from{' '}
                              <a href="https://getemoji.com/" rel="nofollow noopener noreferrer" target="_blank">
                                this page
                              </a>
                              .
                            </div>
                          }
                        />

                        <Checkbox
                          label="Show customer's country"
                          checked={this.state.model.showShopperCountry_ShippingBar}
                          onChange={(newValue) => this.handleChange('showShopperCountry_ShippingBar', newValue)}
                        />

                        <FormLayout.Group>
                          <TextField
                            value={this.state.model.messageBeforeCountry_ShippingBar}
                            onChange={(newValue) => this.handleChange('messageBeforeCountry_ShippingBar', newValue)}
                            label="Message before country"
                          />
                          <TextField
                            value={this.state.model.messageAfterCountry_ShippingBar}
                            onChange={(newValue) => this.handleChange('messageAfterCountry_ShippingBar', newValue)}
                            label="Message after country"
                          />
                        </FormLayout.Group>

                        <Checkbox
                          label="Show Progress Bar"
                          checked={this.state.model.showProgressBar_ShippingBar}
                          onChange={(newValue) => this.handleChange('showProgressBar_ShippingBar', newValue)}
                        />

                        <FormLayout.Group>
                          <ColorPickerCustom
                            label="Progress background color"
                            fieldName="progressBackgroundColor_ShippingBar"
                            value={this.state.model.progressBackgroundColor_ShippingBar}
                            handleChange={this.handleChange}
                          />
                          <ColorPickerCustom
                            label="Progress bar color"
                            fieldName="progressBarColor_ShippingBar"
                            value={this.state.model.progressBarColor_ShippingBar}
                            handleChange={this.handleChange}
                          />
                        </FormLayout.Group>

                        <Checkbox
                          label="Show close button"
                          checked={this.state.model.showCloseButton_ShippingBar}
                          onChange={(newValue) => this.handleChange('showCloseButton_ShippingBar', newValue)}
                        />

                        <Select
                          label="Position"
                          options={[
                            { label: 'Top', value: 'top' },
                            { label: 'Bottom', value: 'bottom' },
                          ]}
                          onChange={(newValue) => this.handleChange('position_ShippingBar', newValue)}
                          value={this.state.model.position_ShippingBar}
                        />

                        <Select
                          label="Shipping cart font size"
                          options={[
                            { label: 'Small', value: JSON.stringify(fontStepValSmall) },
                            { label: 'Medium', value: '' },
                            { label: 'Large', value: JSON.stringify(fontStepValIncrease) },
                            { label: 'Extra Large', value: JSON.stringify(fontStepValIncrease + 2) },
                          ]}
                          onChange={this.handleShippingCart}
                          value={this.state.model.shippingFontSize_ShippingBar}
                        />
                      </span>
                    )}
                  </FormLayout>
                </Card>
              </Layout.AnnotatedSection>

              <Layout.AnnotatedSection title="In cart upsell">
                <Card>
                  <Card.Section>
                    <FormLayout>
                      <Checkbox
                        label="Enabled"
                        checked={this.state.model.enabled_InCartUpsell}
                        onChange={(newValue) => this.handleChange('enabled_InCartUpsell', newValue)}
                      />

                      {this.state.model.enabled_InCartUpsell && (
                        <span>
                          <Checkbox
                            label="Show price"
                            checked={this.state.model.showPrice_InCartUpsell}
                            onChange={(newValue) => this.handleChange('showPrice_InCartUpsell', newValue)}
                          />
                          <br />

                          <Checkbox
                            label="Show compare price"
                            checked={this.state.model.showComparePrice_InCartUpsell}
                            onChange={(newValue) => this.handleChange('showComparePrice_InCartUpsell', newValue)}
                          />
                          <br />

                          <Checkbox
                            label="Show variants dropdown"
                            checked={this.state.model.showVariantsDropdown_InCartUpsell}
                            onChange={(newValue) => this.handleChange('showVariantsDropdown_InCartUpsell', newValue)}
                          />
                          <br />

                          <Checkbox
                            label="Show quantity box"
                            checked={this.state.model.showQuantityBox_InCartUpsell}
                            onChange={(newValue) => this.handleChange('showQuantityBox_InCartUpsell', newValue)}
                          />
                          <br />
                          <br />

                          <LegacyStack vertical spacing="tight">
                            <LegacyStack wrap={false} alignment="center" spacing="tight">
                              <Checkbox
                                label="Enable tracking"
                                checked={this.state.model.trackingEnabled_InCartUpsell}
                                onChange={(newValue) => this.handleChange('trackingEnabled_InCartUpsell', newValue)}
                              />
                              <Tooltip content="This attribute can be used for app auditing and will appear in your Shopify order details page. The attribute name is _Added from Sticky Add To Cart BOOSTER PRO's Cart slider. This is not visible to your customers.">
                                <div style={{ lineHeight: 'normal', marginLeft: '4px' }}>
                                  <Icon source={InfoMinor} color="inkLightest" />
                                </div>
                              </Tooltip>
                            </LegacyStack>
                          </LegacyStack>

                          <br />

                          <TextField
                            value={this.state.model.overwriteProductName_Translation_InCartUpsell}
                            onChange={(newValue) =>
                              this.handleChange('overwriteProductName_Translation_InCartUpsell', newValue)
                            }
                            label="Overwrite product name"
                          />
                          <br />

                          <Select
                            label="Position"
                            options={[
                              { label: 'Top', value: 'top' },
                              { label: 'Bottom', value: 'bottom' },
                            ]}
                            onChange={(newValue) => this.handleChange('position_InCartUpsell', newValue)}
                            value={this.state.model.position_InCartUpsell}
                          />
                          <br />

                          <TextContainer>
                          
                          {!isBannerDismissed('CartSlider.ProductExclusion') && (

                            <Banner title="Product exclusion"
                              onDismiss={() => {
                                  dismissBanner('CartSlider.ProductExclusion');
                                  this.setState((p) => ({ _bannerTick: (p._bannerTick || 0) + 1 }));
                              }}
                            >
                              <p>
                                Sometimes you don't want to show some particular product as an upsell. Products can be excluded
                                from the upsell by tagging them with the exact text <b>Hidden upsell recommendation</b>
                              </p>
                            </Banner>
                          )}
                          </TextContainer>

                          <br />

                          <TextContainer>
                          {!isBannerDismissed('CartSlider.DisablingRecommendations') && (

                            <Banner title="Disabling recommendations"
                              onDismiss={() => {
                                  dismissBanner('CartSlider.DisablingRecommendations');
                                  this.setState((p) => ({ _bannerTick: (p._bannerTick || 0) + 1 }));
                              }}
                            >
                              <p>
                                If you want some product to not show any recommendations you can tag it with the exact text{' '}
                                <b>Upsell recommendations disabled</b>
                              </p>
                            </Banner>
                          )}
                          </TextContainer>
                        </span>
                      )}
                    </FormLayout>
                  </Card.Section>
                </Card>
              </Layout.AnnotatedSection>

              {this.state.model.enabled_InCartUpsell && (
                <>
                  <Layout.AnnotatedSection>
                    <Card>
                      <Card.Section title="Translations">
                        <FormLayout>
                          <FormLayout.Group>
                            <TextField
                              value={this.state.model.addToCart_Translation_InCartUpsell}
                              onChange={(newValue) => this.handleChange('addToCart_Translation_InCartUpsell', newValue)}
                              label="Add to cart"
                            />
                            <TextField
                              value={this.state.model.buyNow_Translation_InCartUpsell}
                              onChange={(newValue) => this.handleChange('buyNow_Translation_InCartUpsell', newValue)}
                              label="Buy now"
                            />
                          </FormLayout.Group>
                          <FormLayout.Group>
                            <TextField
                              value={this.state.model.titleBeforeText_Translation_InCartUpsell}
                              onChange={(newValue) => this.handleChange('titleBeforeText_Translation_InCartUpsell', newValue)}
                              label="Text before product name"
                            />
                            <TextField
                              value={this.state.model.titleAfterText_Translation_InCartUpsell}
                              onChange={(newValue) => this.handleChange('titleAfterText_Translation_InCartUpsell', newValue)}
                              label="Text after product name"
                            />
                          </FormLayout.Group>
                          <FormLayout.Group>
                            <TextField
                              value={this.state.model.soldOut_Translation_InCartUpsell}
                              onChange={(newValue) => this.handleChange('soldOut_Translation_InCartUpsell', newValue)}
                              label="Sold out"
                            />
                            <TextField
                              value={this.state.model.addedToCartMessage_Translation_InCartUpsell}
                              onChange={(newValue) =>
                                this.handleChange('addedToCartMessage_Translation_InCartUpsell', newValue)
                              }
                              label="Added to cart message"
                            />
                          </FormLayout.Group>
                        </FormLayout>
                      </Card.Section>
                    </Card>
                  </Layout.AnnotatedSection>

                  <Layout.AnnotatedSection>
                    <Card>
                      <Card.Section title="Look and feel">
                        <FormLayout>
                          <FormLayout.Group>
                            <ColorPickerCustom
                              label="Background color"
                              fieldName="backgroundColor_InCartUpsell"
                              value={this.state.model.backgroundColor_InCartUpsell}
                              handleChange={this.handleChange}
                            />
                            <ColorPickerCustom
                              label="Title color"
                              fieldName="titleColor_InCartUpsell"
                              value={this.state.model.titleColor_InCartUpsell}
                              handleChange={this.handleChange}
                            />
                          </FormLayout.Group>

                          <FormLayout.Group>
                            <ColorPickerCustom
                              label="Product link color"
                              fieldName="productLinkColor_InCartUpsell"
                              value={this.state.model.productLinkColor_InCartUpsell}
                              handleChange={this.handleChange}
                            />
                            <div />
                          </FormLayout.Group>

                          <FormLayout.Group>
                            <ColorPickerCustom
                              label="Product price color"
                              fieldName="productPriceColor_InCartUpsell"
                              value={this.state.model.productPriceColor_InCartUpsell}
                              handleChange={this.handleChange}
                            />
                            <ColorPickerCustom
                              label="Product compare price color"
                              fieldName="productComparePriceColor_InCartUpsell"
                              value={this.state.model.productComparePriceColor_InCartUpsell}
                              handleChange={this.handleChange}
                            />
                          </FormLayout.Group>

                          <FormLayout.Group>
                            <ColorPickerCustom
                              label="Button background color"
                              fieldName="buttonBackgroundColor_InCartUpsell"
                              value={this.state.model.buttonBackgroundColor_InCartUpsell}
                              handleChange={this.handleChange}
                            />
                            <ColorPickerCustom
                              label="Button background color on hover"
                              fieldName="buttonBackgroundColorOnHover_InCartUpsell"
                              value={this.state.model.buttonBackgroundColorOnHover_InCartUpsell}
                              handleChange={this.handleChange}
                            />
                          </FormLayout.Group>

                          <FormLayout.Group>
                            <ColorPickerCustom
                              label="Button text color"
                              fieldName="buttonTextColor_InCartUpsell"
                              value={this.state.model.buttonTextColor_InCartUpsell}
                              handleChange={this.handleChange}
                            />
                            <ColorPickerCustom
                              label="Button text color on hover"
                              fieldName="buttonTextColorOnHover_InCartUpsell"
                              value={this.state.model.buttonTextColorOnHover_InCartUpsell}
                              handleChange={this.handleChange}
                            />

                            <Select
                              label="Cart upsell font size"
                              options={[
                                { label: 'Small', value: JSON.stringify(fontStepValSmall) },
                                { label: 'Medium', value: '' },
                                { label: 'Large', value: JSON.stringify(fontStepValIncrease) },
                                { label: 'Extra Large', value: JSON.stringify(fontStepValIncrease + 2) },
                              ]}
                              onChange={this.handleInCartUpsell}
                              value={this.state.model.cartFontSize_InCartUpsell}
                            />
                          </FormLayout.Group>
                        </FormLayout>
                      </Card.Section>
                    </Card>
                  </Layout.AnnotatedSection>

                  <Layout.AnnotatedSection>
                    <Card>
                      <Card.Section
                        title={<h3 id="custom-bundles" aria-label="Custom bundles" className="Polaris-Text--headingSm">Custom bundles</h3>}
                        actions={[{ content: 'Add bundle', url: '/upsell-bundle' + this.state.common.shopQueryString + token }]}
                      >
                        <FormLayout>
                          <ResourceList
                            resourceName={{ singular: 'bundle', plural: 'bundles' }}
                            items={this.state.model.bundles_InCartUpsell ? this.state.model.bundles_InCartUpsell : []}
                            renderItem={(item) => {
                              const { id, name } = item;

                              return (
                                <ResourceItem
                                  id={id}
                                  url={'/upsell-bundle/' + this.state.common.shopQueryString + token}
                                  accessibilityLabel={`View details for ${name}`}
                                  name={name}
                                  onClick={() => {
                                    this.props.setBundleID(id);
                                  }}
                                >
                                  <h3>
                                    <Text as="span" fontWeight="semibold">
                                      {name}
                                    </Text>
                                  </h3>
                                </ResourceItem>
                              );
                            }}
                            selectedItems={this.state.selectedBundles}
                            onSelectionChange={(newValue) => this.selectBundles(newValue)}
                            bulkActions={[
                              {
                                content: 'Delete bundles',
                                onAction: () => {
                                  this.deleteBundles();
                                },
                              },
                            ]}
                          />
                        </FormLayout>
                      </Card.Section>

                      <Card.Section title="Global bundles">
                        <FormLayout>
                          <Checkbox
                            label="Global bundles enabled"
                            checked={this.state.model.globalBundlesEnabled_InCartUpsell}
                            onChange={(newValue) => this.handleChange('globalBundlesEnabled_InCartUpsell', newValue)}
                          />

                          <OptionList
                            title={
                              <span className="custom-help-text-margin">
                                <b className="Polaris-Text--root Polaris-Text--headingSm Polaris-Text--semibold">
                                  Recommendation methods
                                </b>
                                <div className="Polaris-Text--root Polaris-Text--bodyMd Polaris-Text--regular">
                                  Each bundle displays differently based on the algorithm or the structure. When multiple bundles
                                  are enabled, it follows top to bottom order of priority.
                                </div>
                              </span>
                            }
                            onChange={(newValue) => this.handleChange('recommendationMethods_InCartUpsell', newValue.sort())}
                            options={[
                              { value: '0', label: lblCustomBundles, disabled: true },
                              { value: '1', label: lblSmartRecommendation },
                              { value: '3', label: lblSameCollection },
                              { value: '4', label: lblSameProductType },
                              { value: '5', label: lblSameVendor },
                              { value: '6', label: lblRandomProduct },
                              { value: '2', label: lblGlobalRecommendation },
                            ]}
                            selected={this.state.model.recommendationMethods_InCartUpsell}
                            allowMultiple
                          />

                          <Checkbox
                            label="Random order"
                            checked={this.state.model.randomOrder_InCartUpsell}
                            onChange={(newValue) => this.handleChange('randomOrder_InCartUpsell', newValue)}
                          />

                          <TextField
                            id="cartSlider_bundledProductsCount_InCartUpsell"
                            label="Bundled products count"
                            type="number"
                            min="1"
                            value={this.state.model.bundledProductsCount_InCartUpsell}
                            onChange={(newValue) => this.handleChange('bundledProductsCount_InCartUpsell', newValue)}
                            error={this.state.error.bundledProductsCount_InCartUpsell ? 'Value must be greater than or equal to 1' : ''}
                            onBlur={() => this.handleBlur('bundledProductsCount_InCartUpsell', 1)}
                          />
                        </FormLayout>
                      </Card.Section>
                    </Card>
                  </Layout.AnnotatedSection>
                </>
              )}

              <Layout.Section>{/* PageActions if needed */}</Layout.Section>
            </Layout>
          </div>

          {/* RIGHT 30% PREVIEW */}
          <div className="cs-editor__right">
            <Card
              title="Preview"
              sectioned
              // actions={[
              //   {
              //     content: this.state.previewActive ? 'Hide' : 'Show',
              //     onAction: this.togglePreviewActive,
              //   },
              // ]}
            >
              <div
                style={{
                  position: 'relative',
                  height: 'calc(100vh - 180px)',
                  overflow: 'hidden',
                  borderRadius: 8,
                }}
              >
                <div
                  className={'satcb-cs' + (this.state.previewActive ? ' satcb-cs-open' : '')}
                  style={{ position: 'absolute', inset: 0, background: 'transparent' }}
                >
                  <div
                    className="satcb-cs-content"
                    style={{
                      fontFamily: this.state.model.fontFace,
                      position: 'absolute',
                      right: 0,
                      top: 0,
                      height: '100%',
                      width: '100%',
                      marginRight: 0,
                      overflowY: 'auto',
                    }}
                  >
                    <div className="satcb-cs-header">
                      <span className="satcb-cs-header-title">
                        {this.state.model.cartTitle_Translation}{' '}
                        <span className="satcb-cs-header-count">{this.state.demoQty}</span>
                      </span>
                      <span className="satcb-cs-close" 
                        // onClick={this.togglePreviewActive}
                      ></span>
                    </div>

                    <div className="satcb-cs-top-container">
                      {this.state.model.enabled_CartReserved && this.state.model.position_CartReserved === 'top' ? (
                        <CartSliderCartReserved model={this.state.model} />
                      ) : (
                        ''
                      )}

                      {this.state.model.enabled_ShippingBar && this.state.model.position_ShippingBar === 'top' ? (
                        <CartSliderShippingBar
                          model={this.state.model}
                          totalPrice={this.state.model.demoProduct ? this.state.model.demoProduct.defaultVariant.price : 0}
                          currency={this.getCurrencySymbol()}
                        />
                      ) : (
                        ''
                      )}

                      {this.state.visibleItem &&
                        this.state.model.enabled_InCartUpsell &&
                        this.state.model.position_InCartUpsell === 'top' ? (
                        <CartSliderInCartUpsell
                          model={this.state.model}
                          product={this.state.model.demoProduct}
                          currency={this.getCurrencySymbol()}
                        />
                      ) : (
                        ''
                      )}
                    </div>

                    <div className={'satcb-cs-items' + (!this.state.visibleItem ? ' satcb-cs-cart-empty' : '')}>
                      {this.state.visibleItem ? (
                        <div className="satcb-cs-item">
                          <div className="satcb-cs-item-img">
                            <a href={this.state.model.demoProduct.url} target="_blank" rel="noreferrer">
                              <img
                                src={this.state.model.demoProduct.imageUrl}
                                alt={this.state.model.demoProduct.title}
                              />
                            </a>
                          </div>
                          <div className="satcb-cs-item-main">
                            <div className="satcb-cs-item-main-top">
                              <div className="satcb-cs-item-main-top-left">
                                <div className="satcb-cs-item-title">
                                  <a href={this.state.model.demoProduct.url} target="_blank" rel="noreferrer">
                                    {this.state.model.demoProduct.title}
                                  </a>
                                </div>
                                <div className="satcb-cs-item-variant">{this.state.model.demoProduct.defaultVariant.title}</div>
                              </div>
                            </div>
                            <span className="satcb-cs-item-close" onClick={this.removeItem}></span>
                            <div className="satcb-cs-item-main-bottom">
                              <div className="satcb-cs-item-qty">
                                <a href="/#" onClick={(e) => this.handleDemoQtyUpDown(-1, e)}>
                                  <svg width="10" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z"></path>
                                  </svg>
                                </a>
                                <input type="text" value={this.state.demoQty} onChange={this.handleChangeDemoQty} />
                                <a href="/#" onClick={(e) => this.handleDemoQtyUpDown(1, e)}>
                                  <svg width="10" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z"></path>
                                  </svg>
                                </a>
                              </div>
                              <span className="satcb-cs-item-price">
                                {this.getCurrencySymbol() + this.state.model.demoProduct.defaultVariant.price}
                              </span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>{this.state.model.cartEmptyText_Translation}</div>
                      )}
                    </div>

                    <div className="satcb-cs-bottom-container">
                      {this.state.model.enabled_CartReserved && this.state.model.position_CartReserved === 'bottom' ? (
                        <CartSliderCartReserved model={this.state.model} />
                      ) : (
                        ''
                      )}

                      {this.state.model.enabled_ShippingBar && this.state.model.position_ShippingBar === 'bottom' ? (
                        <CartSliderShippingBar
                          model={this.state.model}
                          totalPrice={this.state.model.demoProduct ? this.state.model.demoProduct.defaultVariant.price : 0}
                          currency={this.getCurrencySymbol()}
                        />
                      ) : (
                        ''
                      )}

                      {this.state.visibleItem &&
                        this.state.model.enabled_InCartUpsell &&
                        this.state.model.position_InCartUpsell === 'bottom' ? (
                        <CartSliderInCartUpsell
                          model={this.state.model}
                          product={this.state.model.demoProduct}
                          currency={this.getCurrencySymbol()}
                        />
                      ) : (
                        ''
                      )}
                    </div>

                    {this.state.visibleItem ? (
                      <div className={'satcb-cs-footer' + (this.state.model.stickyFooter ? ' satcb-cs-footer-sticky' : '')}>
                        <div className="satcb-cs-footer-subtotal">
                          <span>{this.state.model.subtotal_Translation}</span>
                          <span>{this.getCurrencySymbol() + this.state.model.demoProduct.defaultVariant.price}</span>
                        </div>
                        <div>
                          <div className="satcb-cs-taxes-shipping-note">{this.state.model.taxesAndShippingNote_Translation}</div>
                          <a
                            href="/#"
                            onClick={(e) => e.preventDefault()}
                            style={{
                              backgroundColor: this.state.model.checkoutButtonBackgroundColor,
                              color: this.state.model.checkoutButtonColor,
                            }}
                            className="satcb-cs-checkout-btn"
                          >
                            {this.state.model.checkoutButtonText_Translation}
                          </a>

                          {this.state.model.showViewCart ? (
                            <a href="/#" className="satcb-cs-view-cart" onClick={(e) => e.preventDefault()}>
                              {this.state.model.viewCartText_Translation}
                            </a>
                          ) : (
                            ''
                          )}

                          {this.state.model.showContinueShopping ? (
                            <a href="/#" className="satcb-cs-continue-shopping" onClick={(e) => e.preventDefault()}>
                              {this.state.model.continueShoppingText_Translation}
                            </a>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </Page>
    );
  }

  async populateData() {
    const response = await fetchApi('api/home/cartSlider');
    const data = await response.json();

    if (data.redirectUrl) {
      this.props.navigate(data.redirectUrl);
    } else {
      if (!this.state.common.userName) {
        const commonResponse = await fetchApi('api/home/common');
        const commonData = await commonResponse.json();

        if (commonData.redirectUrl) {
          this.navigate(commonData.redirectUrl);
        } else {
          this.props.setIsLoading(false);
          this.setState({
            initState: JSON.parse(JSON.stringify(data)),
            model: data,
            loading: false,
            visibleItem: data.demoProduct !== null,
            common: commonData,
          });
        }
      } else {
        this.props.setIsLoading(false);
        this.setState({
          initState: JSON.parse(JSON.stringify(data)),
          model: data,
          loading: false,
          visibleItem: data.demoProduct !== null,
        });
      }
    }

    if (
      typeof this.state.model.selectedRemoveProductOption_CartReserved == undefined ||
      (typeof this.state.model.selectedRemoveProductOption_CartReserved != undefined &&
        !this.state.model.selectedRemoveProductOption_CartReserved)
    ) {
      if (this.state.model.clearCartOnTimerEnd_CartReserved) {
        this.setState({ selectedRemoveProductOption_CartReserved: '2' });
      } else {
        this.setState({ selectedRemoveProductOption_CartReserved: '0' });
      }
    }

    setTimeout(() => {
      this.updateSectionSettingsPreview(data.titleFontSize, this.getDefaultFontValuesSectionSettings());
      this.updateCartReservePreview(data.cartInfoFontSize_CartReserved, this.getDefaultFontValuesCartReserve());
      this.updateInCartUpsellPreview(data.cartFontSize_InCartUpsell, this.getDefaultFontValuesInCartUpsell());
      this.updateShippingCartPreview(data.shippingFontSize_ShippingBar, this.getDefaultFontValuesShippingCart());
    }, 1000);
  }

  async saveChanges() {
    var hasError = this.handleBlur('closeAfterSeconds', 2);
    if (hasError) {
      $('#cartSlider_closeAfterSeconds').focus();
      return;
    }

    hasError = this.handleBlur('countdownMinutes_CartReserved', 1);
    if (hasError) {
      $('#cartSlider_countdownMinutes_CartReserved').focus();
      return;
    }

    hasError = this.handleBlur('notShowHours_CartReserved', 0);
    if (hasError) {
      $('#cartSlider_notShowHours_CartReserved').focus();
      return;
    }

    hasError = this.handleBlur('messageFontSize_CartReserved', 1);
    if (hasError) {
      $('#cartSlider_messageFontSize_CartReserved').focus();
      return;
    }

    hasError = this.handleBlur('minAmount_ShippingBar', 0);
    if (hasError) {
      $('#cartSlider_minAmount_ShippingBar').focus();
      return;
    }

    hasError = this.handleBlur('bundledProductsCount_InCartUpsell', 1);
    if (hasError) {
      $('#cartSlider_bundledProductsCount_InCartUpsell').focus();
      return;
    }

    this.props.setIsLoading(true);
    const response = await fetchApi('api/home/saveCartSlider', {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(this.state.model),
    });
    const data = await response.json();

    this.props.setIsLoading(false);

    if (response.ok === true) {
      window?.shopify?.saveBar?.hide('satcb-save-bar');

      if (data.redirectUrl) {
        this.props.navigate(data.redirectUrl);
      } else {
        this.setState({ initState: JSON.parse(JSON.stringify(this.state.model)) });
        this.props.setIsDirty(false);
        this.props.setToastActive(true);
      }
    }
  }
}